import {Component, ElementRef, HostListener, Input, OnDestroy, Renderer2, ChangeDetectionStrategy} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Component({
    selector: 'overlay',
    template: '',
    styleUrls: ['./overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OverlayComponent implements OnDestroy {

    @Input()
    public click$: Observable<any>;

    private readonly clickSubject$ = new Subject<MouseEvent>();

    constructor(
        public elementRef: ElementRef,
        private renderer: Renderer2
    ) {
        this.click$ = this.clickSubject$.asObservable();
    }

    public ngOnDestroy(): void {
        this.clickSubject$.complete();
    }

    /**
     * Copies component's attribute which is responsible for the ViewEncapsulation,
     * and in doing so applies styles of the component to itself.
     * Allows to define styles for the overlay component right in the styles of the logical parent component in case of
     * it's not an ancestor in the DOM structure.
     * @param {Renderer2} parentRenderer renderer service of the parent component, which contains styles
     * for the overlay.
     */
    public inheritViewEncapsulation(parentRenderer: Renderer2): void {
        const probeElement: HTMLElement = parentRenderer.createElement('div');
        const componentAttr = probeElement.attributes[0];

        if (componentAttr) {
            this.renderer.setAttribute(this.elementRef.nativeElement, componentAttr.name, '');
        }
    }

    @HostListener('click', ['$event'])
    public onClick(event: MouseEvent): void {
        this.clickSubject$.next(event);
    }

}
